export default __webpack_public_path__ + "static/img-schroders-distribution-datathon--mobile-1dffa4dcb7f68833d55f68940aa9f0c4.webp";